import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'components/shared/Button';
import BillingSummary from 'components/shared/BillingSummary';
import FlashMessage from 'components/shared/FlashMessage';

import type { CartBilling } from 'domains/cart_billing';

type CartSidebarProps = {
  guid: string;
  billing: CartBilling | null;
  children: React.ReactNode;
};

function CartSidebar(props: CartSidebarProps) {
  const { children, billing, guid } = props;

  const [copyNote, setCopyNote] = useState(false);

  const handleCopyCartId = () => {
    window.navigator.clipboard.writeText(guid).then(() => {
      setCopyNote(true);
      setTimeout(() => {
        setCopyNote(false);
      }, 2000);
    });
  };

  return (
    <div id="sidebar" className="cart-sidebar branding">
      {billing && (
        <div className="sidebar_inner">
          <BillingSummary billing={billing} hideCheckoutTotals />

          {billing.handling_total > 0 && (
            <FlashMessage type="info" message="Crate fees may apply" />
          )}

          {children}

          <div className="cart_id_container">
            <Button type="link" onClick={handleCopyCartId}>
              {copyNote ? 'Copied!' : guid}
              <FontAwesomeIcon icon="clipboard" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CartSidebar;
